import { Navigate, Outlet } from 'react-router-dom';
import { ROUTES } from 'router/routes';
import { useFlagsmithMaintenance } from 'hooks/useFlagsmithMaintenance';

export const FlagsmithWrapper = () => {
  const { isMaintenanceMode } = useFlagsmithMaintenance();

  // If maintenance mode is enabled, redirect to maintenance page
  if (isMaintenanceMode) {
    return <Navigate to={ROUTES.maintenance} replace />;
  }

  // Otherwise, render the normal route
  return <Outlet />;
};
